<script lang="ts">
	import { ArrowBack } from "luxedo-icons"
	import { MaskSidebarController } from "./MaskEditorSidebarController"

	interface Props {
		title: string
		goBack?: () => void
	}

	let { title, goBack = undefined }: Props = $props()
</script>

<div class="flex-row heading-container">
	<button class="icon" onclick={goBack ? goBack : MaskSidebarController.goBack}
		><ArrowBack /></button
	>
	<div class="heading">
		<h3>{title}</h3>
	</div>
</div>

<style>
	.heading-container h3 {
		font-size: var(--h0);
		margin: 0;
	}

	.heading-container {
		margin-bottom: 1rem;
		align-items: center;
		padding-right: 0.5rem;
	}

	.heading-container button {
		margin-right: 0.5rem;
	}

	.heading-container button :global(svg) {
		height: 2rem;
		width: auto;
	}
</style>
